import * as _ from 'lodash';
import * as moment from 'moment-timezone';
import { QueryList } from '@angular/core';
import { Router } from '@angular/router';
import { ChallengeService, TeamMembershipStatus } from 'app/shared/services/challenge.service';
import { UserService } from 'app/shared/services/user.service';
import { Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
/**
 * Component to displayed leaderboard of a challenge
 */
var ChallengeLeaderboardComponent = (function () {
    function ChallengeLeaderboardComponent(userService, challengeService, translate, snackBar, router) {
        var _this = this;
        this.userService = userService;
        this.challengeService = challengeService;
        this.translate = translate;
        this.snackBar = snackBar;
        this.router = router;
        this.teamHasNotEnoughMembers = false;
        // Selected week in overview for users team
        this.selectedUserWeek = 0;
        // Selected week in overview of all teams
        this.selectedTeamWeek = 0;
        this.showWeeklyUserScore = false;
        this.showWeeklyTeamScore = false;
        this.challengeWinnerTeams = {
            first: null,
            second: null,
            third: null,
        };
        // Object containing weeks as keys and weekly winner team as values
        this.weeklyWinners = {};
        // Reference to TeamMembershipStatus to be able to use it in template
        this.TeamMembershipStatus = TeamMembershipStatus;
        this.ngUnsubscribe = new Subject();
        /** Debounce function to reduce email spam */
        this.cheerForTeamMemberDebounced = _.throttle(function (name, userID) {
            _this.cheerForTeamMember(name, userID);
        }, 5000, { leading: true, trailing: false });
    }
    ChallengeLeaderboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userService.currentUser.takeUntil(this.ngUnsubscribe).subscribe(function (user) {
            if (user) {
                _this.currentUser = user;
                _this.setChallengeStatus();
                _this.setTeam();
                _this.scrollIntoView();
            }
        });
        // Trigger team reload in order for points to update
        this.challengeService.reloadTeams();
        this.challengeService.teams.takeUntil(this.ngUnsubscribe).subscribe(function (teams) {
            if (!teams) {
                return;
            }
            _this.unfilteredTeams = teams;
            // Exclude teams which haven't reached the required minimum amount of members to not show them in scoring board
            if (_this.challenge.minimalTeamMembers) {
                teams = teams.filter(function (team) {
                    var teamMembers = team.users.filter(function (user) { return user.membershipStatus === TeamMembershipStatus.MEMBER; });
                    return teamMembers.length >= _this.challenge.minimalTeamMembers;
                });
            }
            _this.teams = teams;
            _this.setTeam();
            _this.buildWeeklyWinners();
            _this.setWinnerTeams();
            _this.scrollIntoView();
        });
    };
    ChallengeLeaderboardComponent.prototype.ngOnChanges = function (changes) {
        if (changes && this.challenge) {
            this.setChallengeStatus();
            this.initializeFilter();
        }
    };
    /**
     * Scrolls within user and team containers, so that user can see the himself and his team in the list
     */
    ChallengeLeaderboardComponent.prototype.scrollIntoView = function () {
        var _this = this;
        // Scroll to current user
        if (this.currentUser && this.allUsers && this.allUsers.length > 0) {
            var element = this.allUsers.find(function (userElement) {
                return userElement.nativeElement.dataset.userid === _this.currentUser._id;
            });
            element.nativeElement.scrollIntoView(false);
        }
        // Scroll to current team
        if (this.team && this.allTeams && this.allTeams.length > 0) {
            var element = this.allTeams.find(function (teamElement) {
                return teamElement.nativeElement.dataset.teamid === _this.team._id;
            });
            element.nativeElement.scrollIntoView(false);
        }
    };
    /**
     * Toggle between total score and weekly score view in user list
     * @param showScore - Whether weekly score should be displayed or totalScore
     */
    ChallengeLeaderboardComponent.prototype.setShowWeeklyUserScore = function (showWeeklyScore) {
        this.showWeeklyUserScore = showWeeklyScore;
        this.sortUsers();
    };
    /**
     * Toggle between total score and weekly score view in team list
     * @param showScore - Whether weekly score should be displayed or totalScore
     */
    ChallengeLeaderboardComponent.prototype.setShowWeeklyTeamScore = function (showWeeklyScore) {
        this.showWeeklyTeamScore = showWeeklyScore;
        this.sortTeams();
    };
    /**
     * Sets the selected week
     * @param week - The week that should be set
     * @param view - Whether week should be changed in "myTeam" section or in "all teams" section
     */
    ChallengeLeaderboardComponent.prototype.setSelectedWeek = function (week, view) {
        var lastDay = this.localizedDaysPassed(this.challenge.start, this.challenge.end, this.currentUser.timeZone);
        var maxWeek = Math.trunc(lastDay / 7);
        if (week >= 0 && week <= maxWeek) {
            if (view === 'users') {
                this.selectedUserWeek = week;
                this.sortUsers();
            }
            if (view === 'teams') {
                this.selectedTeamWeek = week;
                this.sortTeams();
            }
        }
    };
    /**
     * Set whether challenge is in past or not
     */
    ChallengeLeaderboardComponent.prototype.setChallengeStatus = function () {
        if (!this.challenge || !this.currentUser) {
            return;
        }
        this.isPastChallenge = moment(this.challenge.end).isBefore(moment());
        this.setWinnerTeams();
    };
    ChallengeLeaderboardComponent.prototype.setWinnerTeams = function () {
        // Build leaderboard with challenge winners
        if (this.isPastChallenge && this.teams) {
            var teamsCopy = this.teams.slice();
            var sortedByTotalScore = teamsCopy.sort(function (a, b) {
                return (a.points.total || 0) > (b.points.total || 0) ? -1 : 1;
            });
            if (sortedByTotalScore.length > 0) {
                this.challengeWinnerTeams.first = sortedByTotalScore[0];
            }
            else {
                this.challengeWinnerTeams.first = null;
            }
            if (sortedByTotalScore.length > 1) {
                this.challengeWinnerTeams.second = sortedByTotalScore[1];
            }
            else {
                this.challengeWinnerTeams.second = null;
            }
            if (sortedByTotalScore.length > 2) {
                this.challengeWinnerTeams.third = sortedByTotalScore[2];
            }
            else {
                this.challengeWinnerTeams.third = null;
            }
        }
    };
    /**
     * Selects the current week at component initialization
     */
    ChallengeLeaderboardComponent.prototype.initializeFilter = function () {
        if (!this.currentUser || !this.challenge || !this.teams) {
            return;
        }
        var currentDay = this.localizedDaysPassed(this.challenge.start, moment(), this.currentUser.timeZone);
        this.currentChallengeDay = currentDay;
        var currentWeek = Math.trunc(currentDay / 7);
        var lastDay = this.localizedDaysPassed(this.challenge.start, this.challenge.end, this.currentUser.timeZone);
        var maxWeek = Math.trunc(lastDay / 7);
        this.maxWeek = maxWeek;
        // If current week is larger than maxWeek, that means the challenge has already ended.
        // In this case initialize to last week of challenge
        var weekToSet = currentWeek > maxWeek ? maxWeek : currentWeek;
        this.setSelectedWeek(weekToSet, 'users');
        this.setSelectedWeek(weekToSet, 'teams');
    };
    /**
     * Sort team members based on scored points in current selected week
     */
    ChallengeLeaderboardComponent.prototype.sortUsers = function () {
        var _this = this;
        if (!this.team || !this.team.userGroups || !this.team.userGroups.members) {
            return;
        }
        if (this.showWeeklyUserScore) {
            this.team.userGroups.members.sort(function (a, b) {
                return (a.points.byWeek[_this.selectedUserWeek] || 0) > (b.points.byWeek[_this.selectedUserWeek] || 0) ? -1 : 1;
            });
        }
        else {
            this.team.userGroups.members.sort(function (a, b) {
                return (a.points.total || 0) > (b.points.total || 0) ? -1 : 1;
            });
        }
    };
    /**
     * Sort teams based on scored points in current selected week
     */
    ChallengeLeaderboardComponent.prototype.sortTeams = function () {
        var _this = this;
        if (!this.teams) {
            return;
        }
        if (this.showWeeklyTeamScore) {
            this.teams.sort(function (a, b) {
                return (a.points.byWeek[_this.selectedTeamWeek] || 0) > (b.points.byWeek[_this.selectedTeamWeek] || 0) ? -1 : 1;
            });
        }
        else {
            this.teams.sort(function (a, b) {
                return (a.points.total || 0) > (b.points.total || 0) ? -1 : 1;
            });
        }
    };
    /**
     * Sets membership status of user which has effect on the available actions
     */
    ChallengeLeaderboardComponent.prototype.setTeam = function () {
        var _this = this;
        if (!this.teams || !this.currentUser) {
            this.team = undefined;
            this.teamUser = undefined;
            return;
        }
        this.originalTeamUser = null;
        var originalTeam = this.unfilteredTeams.find(function (team) {
            for (var _i = 0, _a = team.users; _i < _a.length; _i++) {
                var user = _a[_i];
                if (user._id === _this.currentUser._id) {
                    _this.originalTeamUser = user;
                    return true;
                }
            }
        });
        if (this.originalTeamUser &&
            this.originalTeamUser.membershipStatus === TeamMembershipStatus.MEMBER &&
            originalTeam.userGroups.members.length < this.challenge.minimalTeamMembers) {
            this.teamHasNotEnoughMembers = true;
        }
        else {
            this.teamHasNotEnoughMembers = false;
        }
        var teamUser = null;
        // If teams are returned, set team the user belongs to
        // Team is only set for members, not if user has invitation or application status
        this.team = this.teams.find(function (team) {
            for (var _i = 0, _a = team.users; _i < _a.length; _i++) {
                var user = _a[_i];
                if (user._id === _this.currentUser._id) {
                    teamUser = user;
                    return true;
                }
            }
        });
        if (!this.team) {
            this.teamUser = null;
        }
        else {
            this.teamUser = teamUser;
        }
        if (this.team) {
            this.initializeFilter();
        }
    };
    /**
     * Build structure to make weekly winners more easily accessible.
     */
    ChallengeLeaderboardComponent.prototype.buildWeeklyWinners = function () {
        this.weeklyWinners = {};
        if (this.teams) {
            for (var _i = 0, _a = this.teams; _i < _a.length; _i++) {
                var team = _a[_i];
                for (var i = 0; i < team.bonuses.weeklyWinner.weeks.length; ++i) {
                    this.weeklyWinners[team.bonuses.weeklyWinner.weeks[i]] = team._id;
                }
            }
        }
    };
    /**
     * Returns difference in days between start and end date in local timezone
     * @param startDate - the earlier date
     * @param endDate - the later date
     * @param timeZone - timeZone of user
     */
    ChallengeLeaderboardComponent.prototype.localizedDaysPassed = function (startDate, endDate, timeZone) {
        // Example:
        // Challenge start is 2020-02-30 23:00 UTC and now is 2020-02-31 03:00
        // In UTC, a new day has started since challenge start
        // In UTC +1 timezone however, both timestamps are at the same day.
        // To allow user timezone differences and still be displayed as the same day,
        // bonuses and points are stored by day number instead of dates and refer to day in users timezone
        var end = moment(endDate).tz(timeZone).endOf('day');
        var start = moment(startDate).tz(timeZone).startOf('day');
        return end.diff(start, 'days');
    };
    /**
     * A user can cheer for other team members to send them a motivation message.
     */
    ChallengeLeaderboardComponent.prototype.cheerForTeamMember = function (name, userID) {
        this.snackBar.open(this.translate.instant('STATS.CHALLENGE_LEADERBOARD.cheerToast', { userName: name }), null, {
            verticalPosition: 'bottom',
            duration: 4000,
            panelClass: ['b2a-success', 'bottom'],
        });
        this.challengeService.cheerForTeamMember(this.challenge._id, this.team._id, userID).then();
    };
    ChallengeLeaderboardComponent.prototype.openChallengeTutorial = function () {
        this.router.navigate(['challengeTutorial']).then();
    };
    /**
     * On destroy cancel active subscriptions
     */
    ChallengeLeaderboardComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return ChallengeLeaderboardComponent;
}());
export { ChallengeLeaderboardComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/challenge-statistics/components/challenge-leaderboard/challenge-leaderboard.component.ts.pre-build-optimizer.js